export const V2_ADDRESS = '0xDe7cdf01605D35B215438BD84648AF5944EB4c57';
export const INFINITY_POOL_ADDRESS = '0xdd6f8436AE01274E4c33C4fD60c6c0b132F524bA';
export const VEHYBRID_ADDRESS = '0x3Ce5a5DF460Ea5acB69E1A59d0b54eA1a283A712';
export const LOCKER_3_ADDRESS = '0x7dEF2cFfaE6d72d4Ed2Fe4B8e893CEE82e7eDe18';
export const LOCKER_6_ADDRESS = '0xC58918f5F6214B1cF9606A8D4F0C871415f178B2';
export const LOCKER_12_ADDRESS = '0x0bb72890B4F5477c13c4cB8EeFF1DE277b67FcF8';
export const USDC_ADDRESS = '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e';
